var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCloseBlack = function SvgIcCloseBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic-close-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m8.146 3.114.354.353.354-.353L11.086.882c.509-.51 1.334-.51 1.844 0l3.188 3.189c.51.509.51 1.334 0 1.843l-2.232 2.232-.353.354.353.354 2.232 2.232c.51.509.51 1.334 0 1.844l-3.188 3.188c-.51.51-1.335.51-1.844 0l-2.232-2.232-.354-.353-.354.353-2.232 2.232c-.509.51-1.334.51-1.843 0L.88 12.93a1.304 1.304 0 0 1 0-1.844l2.233-2.232.353-.354-.353-.354L.882 5.914a1.304 1.304 0 0 1 0-1.843L4.07.88c.509-.508 1.334-.508 1.843 0l2.232 2.233Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic-close-black_svg__a",
    width: 17,
    height: 18,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1416_4513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1416_4513",
    result: "shape"
  })))));
};
export default SvgIcCloseBlack;